var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F4FDE9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1769_1210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5004 21.9L16.3254 19.725C16.1254 19.5417 15.8921 19.45 15.6254 19.45C15.3587 19.45 15.1254 19.5417 14.9254 19.725C14.7087 19.9417 14.6004 20.1875 14.6004 20.4625C14.6004 20.7375 14.7004 20.9667 14.9004 21.15L17.8004 24.075C17.9837 24.2583 18.2129 24.35 18.4879 24.35C18.7629 24.35 19.0004 24.2583 19.2004 24.075L25.0254 18.2C25.2254 18.0167 25.3254 17.7917 25.3254 17.525C25.3254 17.2583 25.2171 17.0167 25.0004 16.8C24.8171 16.6167 24.5837 16.525 24.3004 16.525C24.0171 16.525 23.7754 16.625 23.5754 16.825L18.5004 21.9ZM20.0004 30.35C18.5337 30.35 17.1712 30.0875 15.9129 29.5625C14.6546 29.0375 13.5587 28.3083 12.6254 27.375C11.6921 26.4417 10.9629 25.3458 10.4379 24.0875C9.91289 22.8292 9.65039 21.4667 9.65039 20C9.65039 18.55 9.91289 17.1917 10.4379 15.925C10.9629 14.6583 11.6921 13.5625 12.6254 12.6375C13.5587 11.7125 14.6546 10.9792 15.9129 10.4375C17.1712 9.89583 18.5337 9.625 20.0004 9.625C21.4504 9.625 22.8087 9.89583 24.0754 10.4375C25.3421 10.9792 26.4379 11.7125 27.3629 12.6375C28.2879 13.5625 29.0212 14.6542 29.5629 15.9125C30.1046 17.1708 30.3754 18.5333 30.3754 20C30.3754 21.4667 30.1046 22.8292 29.5629 24.0875C29.0212 25.3458 28.2879 26.4417 27.3629 27.375C26.4379 28.3083 25.3421 29.0375 24.0754 29.5625C22.8087 30.0875 21.4504 30.35 20.0004 30.35Z",
    fill: "#458108"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1769_1210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIconSuccess);
export default __webpack_public_path__ + "static/media/alert_icon_success.70420b871660494d98e885a115f4a94f.svg";
export { ForwardRef as ReactComponent };